import Acl from "./Acl";

type AclInput = string | string[] | undefined | null;
type ActionsMap = Record<string, unknown>;
type AclMap = Record<string, AclInput>;

function getCurrentAcl(): Acl {
  const rawUserData = window.localStorage.getItem("userData");
  if (rawUserData) {
    const userData = JSON.parse(rawUserData) as { permissions?: string[] };
    return buildPermissions(userData.permissions);
  }
  return new Acl();
}

export function buildPermissions(capabilities: string[] = []): Acl {
  const acl = new Acl();
  capabilities.forEach((capability) => {
    acl.allow(capability);
  });
  return acl;
}

export function isAllowed(acl: AclInput): boolean {
  if (acl == null) {
    return false;
  }
  if (Array.isArray(acl)) {
    return acl.some((capability) => {
      return isAllowed(capability);
    });
  } else {
    return getCurrentAcl().isAllowed(acl);
  }
}

export function filterAllowed(actions: ActionsMap, acl: AclMap): ActionsMap {
  const actionsAllowed: ActionsMap = {};
  for (const action in actions) {
    if (!acl[action]) {
      actionsAllowed[action] = actions[action];
    } else if (isAllowed(acl[action])) {
      actionsAllowed[action] = actions[action];
    }
  }
  return actionsAllowed;
}
